
define('modules/application/wizard/classes/solenoidValves',[
  "app",

  // Libs
  "backbone",

  //Classes
  "./genericElement"
],

function(app, Backbone, genericElement) {

  var SolenoidValvesEventAggregator = _.extend({}, Backbone.Events);

  var solenoidValves                = _.extend({}, genericElement, {
    SolenoidValvesEventAggregator : _.extend({}, Backbone.Events),
    Views                         : {

      titleBar  : genericElement.Views.titleBar.extend({
        keep            : true,
        template        : "application/wizard/sections/solenoidValves/titleBar",
        tagName         : "h3",
        eventAggregator : SolenoidValvesEventAggregator,
        events : {
          "click" : "titleBarClickedEventHandler"
        },

        initialize                    : function() {
          this.model.unbind("change:combinedPlant", this.setLabel);
          this.model.bind("change:combinedPlant", this.setLabel, this);

          this.model.unbind("change:heatingPlant", this.setLabel);
          this.model.bind("change:heatingPlant", this.setLabel, this);

          this.model.unbind("change:breezingPlant", this.setLabel);
          this.model.bind("change:breezingPlant", this.setLabel, this);


          this.model.titleBarView = this;
        },

        setLabel                      : function(attributes) {
          var that = this;
          this.$el.find(".caption").text(
            this.model.get("combinedPlant").quantity+
            this.model.get("heatingPlant").quantity +
            this.model.get("breezingPlant").quantity
          );
          this.$el.find(".caption").fadeIn(200);
        },

        titleBarClickedEventHandler   : function(e) {
          this.model.trigger("tooltips:toggle");
        },

        removeLabel                   : function() {
          this.$el.find(".titleBarcontent span").fadeOut(200, function() {$(this).hide();});
        },

        enable                        : function() {
          this.$el.trigger( "click");
        },

        disable                       : function() {
          this.$el.trigger("click");
        }
      }),

      content   : genericElement.Views.content.extend({
        keep            : true,
        template        : "application/wizard/sections/solenoidValves/content",
        className       : "solenoidValves",
        eventAggregator : SolenoidValvesEventAggregator,
        events          : {
          "click    .ui-spinner-up"             : "onClickIncrement",
          "click    .ui-spinner-down"           : "onClickDecrement",
          "focusin  input.spinner"              : "focusInSpinnerEventHandler",
          "focusout input.spinner"              : "focusOutSpinnerEventHandler",
          "keydown  input.spinner"              : "keyDownSpinnerEventHandler",
          "click    .radio"                     : "updateCombinedPlantTypeValue"
        },

        initialize          : function()      {

          this.eventAggregator.unbind("solenoidValveType:chosen",   this.updateActuatorsQuantity);
          this.eventAggregator.bind("solenoidValveType:chosen",     this.updateActuatorsQuantity, this);

          this.eventAggregator.unbind("types:fetched",              this.render);
          this.eventAggregator.bind("types:fetched",                this.render,                 this);

          this.eventAggregator.unbind("combinedType:updated",       this.updateView);
          this.eventAggregator.bind("combinedType:updated",         this.updateView,                 this);

          this.eventAggregator.unbind("combinedType:updated",       this.customizeFormElements);
          this.eventAggregator.bind("combinedType:updated",         this.customizeFormElements,      this);

          this.eventAggregator.unbind("heatingType:updated",        this.updateView);
          this.eventAggregator.bind("heatingType:updated",          this.updateView,                 this);

          this.eventAggregator.unbind("heatingType:updated",        this.customizeFormElements);
          this.eventAggregator.bind("heatingType:updated",          this.customizeFormElements,      this);

          this.eventAggregator.unbind("breezingType:updated",       this.updateView);
          this.eventAggregator.bind("breezingType:updated",         this.updateView,                 this);

          this.eventAggregator.unbind("breezingType:updated",       this.customizeFormElements);
          this.eventAggregator.bind("breezingType:updated",         this.customizeFormElements,      this);

          this.eventAggregator.unbind("combinedPlantType:required", this.render);
          this.eventAggregator.bind("combinedPlantType:required",   this.render,          this);

          this.eventAggregator.unbind("combinedPlantType:required", this.disableHeatingTypeSelector);
          this.eventAggregator.bind("combinedPlantType:required",   this.disableHeatingTypeSelector, this);

          this.eventAggregator.unbind("combinedPlantType:required", this.disableBreezingTypeSelector);
          this.eventAggregator.bind("combinedPlantType:required",   this.disableBreezingTypeSelector,this);

          this.eventAggregator.unbind("combinedPlantType:required", this.customizeFormElements);
          this.eventAggregator.bind("combinedPlantType:required",   this.customizeFormElements,      this);

          this.eventAggregator.unbind("combinedPlantType:unrequired",this.hideCombinedPlant);
          this.eventAggregator.bind("combinedPlantType:unrequired", this.hideCombinedPlant,          this);

          this.eventAggregator.unbind("combinedPlantType:unrequired",this.enableHeatingTypeSelector);
          this.eventAggregator.bind("combinedPlantType:unrequired", this.enableHeatingTypeSelector,  this);

          this.eventAggregator.unbind("combinedPlantType:unrequired",this.enableBreezingTypeSelector);
          this.eventAggregator.bind("combinedPlantType:unrequired", this.enableBreezingTypeSelector, this);

          this.eventAggregator.unbind("combinedPlantType:unrequired",this.customizeFormElements);
          this.eventAggregator.bind("combinedPlantType:unrequired", this.customizeFormElements,      this);

          this.eventAggregator.unbind("combinedPlantType:unrequired",this.customizeFormElements);
          this.eventAggregator.bind("combinedPlantType:unrequired", this.customizeFormElements,      this);

          this.model.unbind("change:combinedPlant",                 this.updateActuatorsQuantity);
          this.model.bind("change:combinedPlant",                   this.updateActuatorsQuantity,    this);

          this.model.unbind("change:heatingPlant",                  this.changeHeatingType);
          this.model.bind("change:heatingPlant",                    this.changeHeatingType,          this);

          this.model.unbind("change:breezingPlant",                 this.changeBreezingType);
          this.model.bind("change:breezingPlant",                   this.changeBreezingType,         this);

          this.model.unbind("render:requested",                     this.render);
          this.model.bind("render:requested",                       this.render,                     this);
        },

        serialize                       : function() {
          return genericElement.Views.content.prototype.serialize.apply(this);
        },

        updateActuatorsQuantity : function() {
          this.$el.find("#combinedActuatorQuantity").html(this.model.get("combinedPlant").quantity);
          this.$el.find("#heatingActuatorQuantity").html(this.model.get("heatingPlant").quantity);
          this.$el.find("#breezingActuatorQuantity").html(this.model.get("breezingPlant").quantity);
          if ((this.model.get("combinedPlant").quantity===0)&&(this.model.get("heatingPlant").quantity===0)&&(this.model.get("breezingPlant").quantity===0))
            this.model.get("zoneEventAggregator").trigger("solenoidValve:removed");
          else
            this.model.get("zoneEventAggregator").trigger("solenoidValve:chosen");
        },

        combinedTypeChanged : function(e)      {
          this.model.set("naturalHideDone", true);
          this.model.setCombinedType(e.target.value);
          if (e.target.value!=="")
            this.enableCombinedSpinner();
          else
            this.disableCombinedSpinner();

          if (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0){
            this.eventAggregator.trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
            this.model.get("zoneEventAggregator").trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
          }
        },

        breezingTypeChanged : function(e)      {
          this.model.set("naturalHideDone", true);
          return this.model.setBreezingType(e.target.value);
        },

        changeBreezingType : function(e)      {
          this.model.set("naturalHideDone", true);
          if (e.changed.breezingPlant.type!=="")
            this.enableBreezingSpinner();
          else {
            this.disableBreezingSpinner();
          }
          this.updateActuatorsQuantity();
          if (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0){
            this.eventAggregator.trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
            this.model.get("zoneEventAggregator").trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
          }
        },

        heatingTypeChanged : function(e)      {
          this.model.set("naturalHideDone", true);
          return this.model.setHeatingType(e.target.value);
        },

        changeHeatingType  : function(e) {
          if (e.changed.heatingPlant.type!=="")
            this.enableHeatingSpinner();
          else {
            this.disableHeatingSpinner();
          }
          this.updateActuatorsQuantity();
          if (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0) {
            this.eventAggregator.trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
            this.model.get("zoneEventAggregator").trigger("solenoidValveType:chosen", this.model.theresOneFancoil(), (this.model.get("combinedPlant").quantity+this.model.get("heatingPlant").quantity+this.model.get("breezingPlant").quantity>0));
          }
        },

        enableCombinedSpinner : function()    {
          var spinner = this.$el.find(".combinedPlantTypeContainer .spinner-container");
          _.each(spinner.children("button"), function(button) {
            $(button).removeAttr("disabled");
          });
          
          /* setValue Combined Spinner Input */
          var spinnerInput = $(this.$el.find('#combinedActuatorQuantity'));
          spinnerInput.val(this.model.get("combinedPlant").quantity);

          spinner.children(".spinner").html(this.model.get("combinedPlant").quantity);
          spinner.removeClass("disabled");
          this.enableHeatingSpinner();
          this.enableBreezingSpinner();
        },

        disableCombinedSpinner : function()    {
          var spinner = this.$el.find(".combinedPlantTypeContainer .spinner-container");
          _.each(spinner.children("button"), function(button) {
            $(button).attr("disabled","disabled");
          });
          spinner.addClass("disabled");
          spinner.children(".spinner").html("0");
          this.disableHeatingSpinner();
          this.disableBreezingSpinner();
        },

        enableHeatingSpinner : function()    {
          var spinner = this.$el.find(".heating .spinner-container");
          _.each(spinner.children("button"), function(button) {
            $(button).removeAttr("disabled");
          });
          
          /* setValue Heating Spinner Input */
          var spinnerInput = $(this.$el.find('#heatingActuatorQuantity'));
          spinnerInput.val(this.model.get("heatingPlant").quantity);

          spinner.removeClass("disabled");
        },

        disableHeatingSpinner : function()    {
          var spinner = this.$el.find(".heating .spinner-container");
          _.each(spinner.children("button"), function(button) {
            $(button).attr("disabled","disabled");
          });
          spinner.addClass("disabled");
          spinner.children(".spinner").html("0");
        },

        enableBreezingSpinner : function()    {
          var spinner = this.$el.find(".breezing .spinner-container");
          _.each(spinner.children("button"), function(button) {
            $(button).removeAttr("disabled");
          });

          /* setValue Breezing Spinner Input */
          var spinnerInput = $(this.$el.find('#breezingActuatorQuantity'));
          spinnerInput.val(this.model.get("breezingPlant").quantity);

          spinner.removeClass("disabled");
        },

        disableBreezingSpinner : function()    {
          var spinner = this.$el.find(".breezing .spinner-container");
          _.each(spinner.children("button"), function(button) {
            if ($(button).attr("disabled")==="disabled")
              $(button).attr("disabled","disabled");
          });
          spinner.addClass("disabled");
          spinner.children(".spinner").html("0");
        },

        keyDownSpinnerEventHandler: function(e) {
          var currentSpinner = $(e.currentTarget);
          if (e.which !== 8 && e.which !== 9 && !(e.keyCode >= 48 && e.keyCode <= 57) && !(e.keyCode >= 95 && e.keyCode < 106)) {
            return false;
          } else {
            if (currentSpinner.val().length === 3 && e.which !== 8) {
              return false;
            } else {
              return true;
            }
          }
        },

        focusInSpinnerEventHandler: function(e) {
          var sender = e.currentTarget.id;
          var currentSpinner = $(e.currentTarget);
          this.lastValue = currentSpinner.val();
        },

        focusOutSpinnerEventHandler: function(e) {
          var sender = e.currentTarget.id;
          var currentSpinner = $(e.currentTarget);
          var newValue = currentSpinner.val();
          var undoUpdate = false;
          

          if (isNaN(newValue))
          {
            alert("i18n solenoidValves.js (row 312): NUMERO TROPPO GRANDE");
          }
          else
          {
            switch (sender) {
              case 'combinedActuatorQuantity': if (this.model.isPossibleToChangeCombinedValue(Number(newValue)))
                                               { this.model.setCombinedQuantity(Number(newValue)); }
                                               else
                                               { undoUpdate = true; }
                                               break;
              case 'heatingActuatorQuantity' : if (this.model.isPossibleToChangeHeatingValue(Number(newValue)))
                                               { this.model.setHeatingQuantity(Number(newValue)); }
                                               else
                                               { undoUpdate = true; }
                                               break;
              case 'breezingActuatorQuantity': if (this.model.isPossibleToChangeBreezingValue(Number(newValue)))
                                               { this.model.setBreezingQuantity(Number(newValue)); }
                                               else
                                               { undoUpdate = true; }
                                               break;
            }

            if (undoUpdate) {
              currentSpinner.val(this.lastValue);
              alert("i18n solenoidValves.js (row 336): NUMERO TROPPO GRANDE");
            }

          }
        },

        onClickIncrement : function(e){
          var sender = e.currentTarget.id;
          var NewValue;
          var currentSpinner;
          switch (sender) {
            case 'combined-spinner-up': newValue = this.model.incrementCombined();
                                        currentSpinner = $(this.$el.find('#combinedActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
            case 'heating-spinner-up' : newValue = this.model.incrementHeating();
                                        currentSpinner = $(this.$el.find('#heatingActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
            case 'breezing-spinner-up': newValue = this.model.incrementBreezing();
                                        currentSpinner = $(this.$el.find('#breezingActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
          }
        },

        onClickDecrement : function(e){
          var sender = e.currentTarget.id;
          var NewValue;
          var currentSpinner;
          switch (sender) {
            case 'combined-spinner-down': newValue = this.model.decrementCombined();
                                        currentSpinner = $(this.$el.find('#combinedActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
            case 'heating-spinner-down' : newValue = this.model.decrementHeating();
                                        currentSpinner = $(this.$el.find('#heatingActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
            case 'breezing-spinner-down': newValue = this.model.decrementBreezing();
                                        currentSpinner = $(this.$el.find('#breezingActuatorQuantity'));
                                        currentSpinner.val(newValue);
                                        break;
          }
        },

        enableHeatingTypeSelector    : function() {
          this.$el.find("select[name='heatingType']").removeAttr("rel");
          this.$el.find("select[name='heatingType']").removeAttr("disabled");
          this.$el.find("span#selectheatingType").remove();
        },

        enableBreezingTypeSelector   : function() {
          this.$el.find("select[name='breezingType']").removeAttr("rel");
          this.$el.find("select[name='breezingType']").removeAttr("disabled");
          this.$el.find("span#selectbreezingType").remove();
        },

        disableHeatingTypeSelector   : function() {
          this.$el.find("select[name='heatingType']").removeAttr("rel");
          this.$el.find("select[name='heatingType']").attr("disabled", "disabled");
          this.$el.find("select[name='heatingType'] option").removeAttr("selected");
          this.$el.find("span#selectheatingType").remove();
        },

        disableBreezingTypeSelector  : function() {
          this.$el.find("select[name='breezingType']").removeAttr("rel");
          this.$el.find("select[name='breezingType']").attr("disabled", "disabled");
          this.$el.find("select[name='breezingType'] option").removeAttr("selected");
          this.$el.find("span#selectbreezingType").remove();
        },

        updateCombinedPlantTypeValue : function() {
          if ($("input[name='combinedPlantType']:checked").val()==="yes") {
            this.model.enableCombinedPlantType();
          }
          else {
            this.model.disableCombinedPlantType();
          }
        },

        updateView                   : function() {

          //Updating quantities
          this.$el.find("#combinedActuatorQuantity").html(this.model.get("combinedPlant").quantity);
          this.$el.find("#heatingActuatorQuantity").html(this.model.get("heatingPlant").quantity);
          this.$el.find("#breezingActuatorQuantity").html(this.model.get("breezingPlant").quantity);

          //Updating types
          if (this.model.get("combinedPlantType")) {
            this.$el.find("select[name='heatingType']").removeAttr("rel");
            this.$el.find("span#selectheatingType").remove();
            this.$el.find("select[name='heatingType'] option").removeAttr("selected");
            this.$el.find("select[name='heatingType'] option[value='"+this.model.get("combinedPlant").type+"']").attr("selected", "selected");

            if (this.model.get("combinedPlant").type!=="")
              $(".heating .spinner-container").removeClass("disabled");
            else
              $(".heating .spinner-container").addClass("disabled");

            this.$el.find("select[name='breezingType']").removeAttr("rel");
            this.$el.find("span#selectbreezingType").remove();
            this.$el.find("select[name='breezingType'] option").removeAttr("selected");
            this.$el.find("select[name='breezingType'] option[value='"+this.model.get("combinedPlant").type+"']").attr("selected", "selected");

            if (this.model.get("combinedPlant").type!=="")
              $(".breezing .spinner-container").removeClass("disabled");
            else
              $(".breezing .spinner-container").addClass("disabled");
          }
          else {
            this.$el.find("select[name='heatingType']").removeAttr("rel");
            this.$el.find("span#selectheatingType").remove();
            this.$el.find("select[name='heatingType'] option").removeAttr("selected");
            this.$el.find("select[name='heatingType'] option[value='"+this.model.get("heatingPlant").type+"']").attr("selected", "selected");

            if (this.model.get("heatingPlant").type!=="")
              $(".heating .spinner-container").removeClass("disabled");
            else
              $(".heating .spinner-container").addClass("disabled");

            this.$el.find("select[name='breezingType']").removeAttr("rel");
            this.$el.find("span#selectheatingType").remove();
            this.$el.find("select[name='breezingType'] option").removeAttr("selected");
            this.$el.find("select[name='breezingType'] option[value='"+this.model.get("breezingPlant").type+"']").attr("selected", "selected");

            if (this.model.get("breezingPlant").type!=="")
              $(".breezing .spinner-container").removeClass("disabled");
            else
              $(".breezing .spinner-container").addClass("disabled");

          }
          this.setDetails();
          this.customizeFormElements();
        },

        disableSection                    : function(force)                        {
          if (!this.model.get("enabled")||((force!==undefined)&&(force===true)))
          {
            this.hideDetails();
          }
        },

        enableSection                     : function()                             {
        },

        setDetails                        : function(id)                           {
          var choosenType, links, i, j, k, paperToAppend, imageToAppend, videoToAppend;
          this.$el.find(".exampleImage").attr("src",this.model.get("image"));
          this.$el.find(".description").html(this.model.get("packageClassDescription"));

          if (this.model.get("combinedPlant").type!=="") {
            choosenType = this.model.get("combinedPlant").type;
          }

          this.showDetails();
        },

        showDetails                       : function()                             {
          this.$el.find(".exampleImage").fadeIn(200);
          this.$el.find(".description").fadeIn(200);
          this.$el.find(".linkContainer").fadeIn(200);
        },

        hideDetails                       : function()                             {
          this.$el.find(".exampleImage").fadeOut(200,  function() {$(this).hide();});
          this.$el.find(".description").fadeOut(200,   function() {$(this).hide();});
          this.$el.find(".linkContainer").fadeOut(200, function() {$(this).hide();});
        },

        showCombinedPlant                 : function()                             {
          this.$el.find(".combinedPlantTypeContainer select option").removeAttr("selected");
          this.$el.find(".combinedPlantTypeContainer select option[value='']").attr("selected","selected");
          this.$el.find(".combinedPlantTypeContainer select").removeAttr("rel");
          this.$el.find(".combinedPlantTypeContainer select").removeAttr("disabled");
          this.$el.find("span#selectcombinedType").remove();
          this.$el.find("#combinedActuatorQuantity").html(0);

          if (this.model.get("combinedPlant").type!=="")
            $(".heating .spinner-container").removeClass("disabled");
          else
            $(".heating .spinner-container").addClass("disabled");

          if (this.model.get("combinedPlant").type!=="")
            $(".breezing .spinner-container").removeClass("disabled");
          else
            $(".breezing .spinner-container").addClass("disabled");

          this.customizeFormElements();
          this.$el.find(".combinedPlantTypeContainer").show();
          this.$el.find(".plantType.breezing").hide();
          this.$el.find(".plantType.heating").hide();
        },

        hideCombinedPlant                 : function()                             {
          this.$el.find(".combinedPlantTypeContainer").hide();
          this.$el.find(".plantType.breezing").show();
          this.$el.find(".plantType.heating").show();
        },

        isOpen                            : function()                             {
          return this.$el.css("display")=="block";
        },

        customizeFormElements             : function()                             {
          //Customizing form elements
          setTimeout(function() {
            window.customizeFormElements.call();
          }, 0);
        },

        afterRender                       : function()                             {
          var that = this;
          var lastHeatingTypeValue;
          var lastBreezingTypeValue;
          var lastCombinedTypeValue;

          this.$el.find("#heatingType")
          .bind("click",
            function(e){
            lastHeatingTypeValue = $(this).val();
          })
          .bind("change",
            function(e){
              if (!that.heatingTypeChanged(e))
                $(this).val(lastHeatingTypeValue);
          });

          this.$el.find("#breezingType")
          .bind("click",
            function(e){
              lastBreezingTypeValue = $(this).val();
          })
          .bind("change",
            function(e){
              if (!that.breezingTypeChanged(e))
                $(this).val(lastBreezingTypeValue);
          });

          this.$el.find("#combinedType").bind("change",
            function(e){
              that.combinedTypeChanged(e);
          });

          //Customizing form elements
          setTimeout(function() {
            window.customizeFormElements.call();
          }, 0);

        },

        onClose                           : function()                             {
          this.unbind("actuators:incremented");
          this.unbind("actuators:decremented");

          this.eventAggregator.unbind("combinedType:updated");
          this.eventAggregator.unbind("combinedType:updated");

          this.eventAggregator.unbind("heatingType:updated");
          this.eventAggregator.unbind("heatingType:updated");

          this.eventAggregator.unbind("breezingType:updated");
          this.eventAggregator.unbind("breezingType:updated");

          this.eventAggregator.unbind("combinedPlantType:required");
          this.eventAggregator.unbind("combinedPlantType:required");
          this.eventAggregator.unbind("combinedPlantType:required");
          this.eventAggregator.unbind("combinedPlantType:required");

          this.eventAggregator.unbind("combinedPlantType:unrequired");
          this.eventAggregator.unbind("combinedPlantType:unrequired");
          this.eventAggregator.unbind("combinedPlantType:unrequired");
          this.eventAggregator.unbind("combinedPlantType:unrequired");

          this.eventAggregator.unbind("combinedPlantType:unrequired");
        }
      })

    },

    Model : genericElement.Model.extend({

      defaults : {
        plantTypes          : [],
        combinedPlantType   : false,
        combinedPlant       : {
          type     : "",
          quantity : 0,
          minValue : 1,
          maxValue : 9
        },
        heatingPlant        : {
          type     : "",
          quantity : 0,
          minValue : 1,
          maxValue : 9
        },
        breezingPlant       : {
          type     : "",
          quantity : 0,
          minValue : 1,
          maxValue : 9
        },
        eventAggregator     : SolenoidValvesEventAggregator
      },

      events              : {
        "change:combinedPlant.type" : "combinedPlantTypeUpdated"
      },

      initialize          : function()            {
        window.BticinoS4B.eventAggregator.unbind("mainControlUnit:chosen",  this.mainControlUnitChosenEventHandler);
        window.BticinoS4B.eventAggregator.bind("mainControlUnit:chosen",    this.mainControlUnitChosenEventHandler, this);


        if(!this.get("combinedPlant").minValue)
          this.set("combinedPlant", _.extend(this.get("combinedPlant"), {minValue : 1, maxValue : 9}));
        if(!this.get("heatingPlant").minValue)
          this.set("heatingPlant", _.extend(this.get("heatingPlant"), {minValue : 1, maxValue : 9}));
        if(!this.get("breezingPlant").minValue)
          this.set("breezingPlant", _.extend(this.get("breezingPlant"), {minValue : 1, maxValue : 9}));

        this.fetchTypes();
      },

      mainControlUnitChosenEventHandler : function() {
        this.fetchTypes();
      },

      checkValidity       : function()            {
        //if ((this.get("combinedPlant").quantity+this.get("heatingPlant").quantity+this.get("breezingPlant").quantity)<1)
        //  this.get("stepEventAggregator").trigger("solenoidValve:removed");
      },

      isPossibleToChangeCombinedValue : function(value) {
        var combinedPlantModel = _.extend({}, this.get("combinedPlant"));
        if ( value <= combinedPlantModel.maxValue )
          { return true; }
        else
          { return false; }
      },

      setCombinedQuantity : function(newValue)  {
        var combinedPlantModel = _.extend({}, this.get("combinedPlant"));

        if (newValue<combinedPlantModel.minValue){
          this.set("combinedPlant", _.extend(combinedPlantModel, {quantity : 0}));
          this.resetCombinedPlant();
        }
        else if (combinedPlantModel.quantity>=combinedPlantModel.minValue)  {
          this.set("combinedPlant", _.extend(combinedPlantModel, {quantity : newValue}));
          this.checkValidity();
        }

        return this.get("combinedPlant").quantity;

      },

      isPossibleToChangeBreezingValue : function(value) {
        var breezingPlantModel = _.extend({}, this.get("breezingPlant"));
        var heatingPlantModel = _.extend({}, this.get("heatingPlant"));
        if ( breezingPlantModel.maxValue >= ( heatingPlantModel.quantity + value ))
          { return true; }
        else
          { return false; }
      },

      setBreezingQuantity : function(newValue)  {
        var breezingPlantModel = _.extend({}, this.get("breezingPlant"));
        
        if (newValue<breezingPlantModel.minValue){
          this.set("combinedPlant", _.extend(breezingPlantModel, {quantity : 0}));
          this.resetBreezingPlant();
        }
        else if (breezingPlantModel.quantity>=breezingPlantModel.minValue)  {
          this.set("combinedPlant", _.extend(breezingPlantModel, {quantity : newValue}));
          this.checkValidity();
        }

        return this.get("breezingPlant").quantity;

      },

      isPossibleToChangeHeatingValue : function(value) {
        var breezingPlantModel = _.extend({}, this.get("breezingPlant"));
        var heatingPlantModel = _.extend({}, this.get("heatingPlant"));
        if ( heatingPlantModel.maxValue >= ( breezingPlantModel.quantity + value ))
          { return true; }
        else
          { return false; }
      },

      setHeatingQuantity : function(newValue)  {
        var heatingPlantModel = _.extend({}, this.get("heatingPlant"));

        if (newValue<heatingPlantModel.minValue){
          this.set("heatingPlant", _.extend(heatingPlantModel, {quantity : 0}));
          this.resetHeatingPlant();
        }
        else if (heatingPlantModel.quantity>=heatingPlantModel.minValue)  {
          this.set("heatingPlant", _.extend(heatingPlantModel, {quantity : newValue}));
          this.checkValidity();
        }

        return this.get("heatingPlant").quantity;

      },

      resetCombinedPlant: function()            {
        var combinedPlantModel = _.extend({}, this.get("combinedPlant"));
        this.set("combinedPlant", _.extend(combinedPlantModel, {type : "", quantity : 0, productCode : ""}));
        this.trigger("render:requested");
      },

      resetBreezingPlant: function()            {
        var breezingPlantModel = _.extend({}, this.get("breezingPlant"));
        this.set("breezingPlant", _.extend(breezingPlantModel, {type : "", quantity : 0, productCode : ""}));
        this.trigger("render:requested");
      },

      resetHeatingPlant: function()            {
        var heatingPlantModel = _.extend({}, this.get("heatingPlant"));
        this.set("heatingPlant", _.extend(heatingPlantModel, {type : "", quantity : 0, productCode : ""}));
        this.trigger("render:requested");
      },

      //Increment number of actuators
      incrementCombined : function()              {
        var combinedPlant = _.extend({}, this.get("combinedPlant"));
        if (combinedPlant.quantity < combinedPlant.maxValue) {
          this.set("combinedPlant", _.extend(combinedPlant, {quantity : combinedPlant.quantity+1}));
          this.trigger("actuators:incremented");
        }
        if ((combinedPlant.quantity + this.get("heatingPlant").quantity + this.get("breezingPlant").quantity) < 1)
          { this.get("zoneEventAggregator").trigger("solenoidValve:removed"); }
        else
          { this.get("zoneEventAggregator").trigger("solenoidValve:chosen"); }

        return combinedPlant.quantity;
      },

      incrementHeating    : function()            {
        var heatingPlant = _.extend({}, this.get("heatingPlant"));
        if (heatingPlant.quantity + this.get("breezingPlant").quantity < heatingPlant.maxValue) {
          this.set("heatingPlant", _.extend(heatingPlant, {quantity : heatingPlant.quantity+1}));
          this.trigger("actuators:incremented");
        }

        if ((this.get("combinedPlant").quantity + heatingPlant.quantity + this.get("breezingPlant").quantity) < 1)
          { this.get("zoneEventAggregator").trigger("solenoidValve:removed"); }
        else
          { this.get("zoneEventAggregator").trigger("solenoidValve:chosen"); }

        return heatingPlant.quantity;
      },

      incrementBreezing   : function()            {
        var breezingPlant = _.extend({}, this.get("breezingPlant"));
        if (this.get("heatingPlant").quantity + breezingPlant.quantity < breezingPlant.maxValue) {
          this.set("breezingPlant", _.extend(breezingPlant, {quantity : breezingPlant.quantity+1}));
          this.trigger("actuators:incremented");
        }

        if ((this.get("combinedPlant").quantity + this.get("heatingPlant").quantity + breezingPlant.quantity) < 1)
          { this.get("zoneEventAggregator").trigger("solenoidValve:removed"); }
        else
          { this.get("zoneEventAggregator").trigger("solenoidValve:chosen"); }

        return breezingPlant.quantity;
      },
      /*
        Segnalazione Mantis: 0597
        Quando la quantità viene decrematata a 0 in automatico l'item viene deselezionato  
      */
      //Decrement number of actuators
      decrementCombined : function()              {
        var currentCombinedPlant = _.extend({}, this.get("combinedPlant"));

        if (currentCombinedPlant.quantity===currentCombinedPlant.minValue){
          this.resetCombinedPlant();
        }
        else if (currentCombinedPlant.quantity>currentCombinedPlant.minValue)  {
          this.set("combinedPlant", _.extend(currentCombinedPlant, {quantity : currentCombinedPlant.quantity-1}));
          this.trigger("actuators:decremented");
          this.checkValidity();
        }

        if (this.get("combinedPlant").quantity+this.get("heatingPlant").quantity+this.get("breezingPlant").quantity<1)
            this.get("zoneEventAggregator").trigger("solenoidValve:removed");

        return this.get("combinedPlant").quantity;
      },

      decrementHeating : function()               {
        var currentHeatingPlant = _.extend({}, this.get("heatingPlant"));

        if (currentHeatingPlant.quantity===currentHeatingPlant.minValue){
          this.resetHeatingPlant();
        }
        else if (currentHeatingPlant.quantity>currentHeatingPlant.minValue) {
          this.set("heatingPlant", _.extend(currentHeatingPlant, {quantity : currentHeatingPlant.quantity-1}));
          this.trigger("actuators:decremented");
          this.checkValidity();
        }

        if (this.get("combinedPlant").quantity+this.get("heatingPlant").quantity+this.get("breezingPlant").quantity<1)
            this.get("zoneEventAggregator").trigger("solenoidValve:removed");

        return this.get("heatingPlant").quantity;
      },

      decrementBreezing : function()              {
        var currentbreezingPlant = _.extend({}, this.get("breezingPlant"));

        if (currentbreezingPlant.quantity===currentbreezingPlant.minValue){
          this.resetBreezingPlant();
        }
        else if (currentbreezingPlant.quantity>currentbreezingPlant.minValue)  {
          this.set("breezingPlant", _.extend(currentbreezingPlant, {quantity : currentbreezingPlant.quantity-1}));
          this.trigger("actuators:decremented");
          this.checkValidity();
        }

        if (this.get("combinedPlant").quantity+this.get("heatingPlant").quantity+this.get("breezingPlant").quantity<1)
            this.get("zoneEventAggregator").trigger("solenoidValve:removed");

        return this.get("breezingPlant").quantity;
      },

      enableCombinedPlantType  : function()       {
        var heatingPlant  = _.extend({}, this.get("heatingPlant"));
        var breezingPlant = _.extend({}, this.get("breezingPlant"));
        var combinedPlant = _.extend({}, this.get("combinedPlant"));
        this.set("combinedPlantType", true);
        heatingPlant.minValue       =0;
        heatingPlant.quantity       =0;
        heatingPlant.type           ="";
        breezingPlant.minValue      =0;
        breezingPlant.quantity      =0;
        breezingPlant.type          ="";
        combinedPlant.type          ="";
        combinedPlant.quantity      =0;
        this.set("heatingPlant",  heatingPlant);
        this.set("breezingPlant", breezingPlant);
        this.set("combinedPlant", combinedPlant);
        this.get("eventAggregator").trigger("combinedPlantType:required");
        this.get("zoneEventAggregator").trigger("solenoidValve:removed");
        this.trigger("render:requested");
      },

      disableCombinedPlantType  : function()      {
        var heatingPlant  = _.extend({}, this.get("heatingPlant"));
        var breezingPlant = _.extend({}, this.get("breezingPlant"));
        var combinedPlant = _.extend({}, this.get("combinedPlant"));
        heatingPlant.minValue =1;
        breezingPlant.minValue=1;
        heatingPlant.type           ="";
        breezingPlant.type          ="";
        this.set("combinedPlantType", false);
        combinedPlant.type          ="";
        combinedPlant.quantity      =0;
        this.set("heatingPlant", heatingPlant);
        this.set("breezingPlant", breezingPlant);
        this.set("combinedPlant", combinedPlant);
        this.get("eventAggregator").trigger("combinedPlantType:unrequired");
        this.trigger("render:requested");
      },

      setCombinedType           : function(newCombinedType) {

        var combinedPlant = _.extend({},this.get("combinedPlant"));
        var heatingPlant  = _.extend({},this.get("heatingPlant"));
        var breezingPlant = _.extend({},this.get("breezingPlant"));

        if (newCombinedType==="") {
          this.set("combinedPlant", _.extend(combinedPlant, {type : newCombinedType, quantity : 0}));
          this.set("heatingPlant",  _.extend(combinedPlant, {type : newCombinedType, quantity : 0}));
          this.set("breezingPlant", _.extend(combinedPlant, {type : newCombinedType, quantity : 0}));
        }
        else {
          this.set("combinedPlant", _.extend(combinedPlant, {type  : newCombinedType, quantity : this.get("combinedPlant").minValue}));
          this.set("heatingPlant", _.extend(heatingPlant,   {type  : "", quantity : this.get("heatingPlant").quantity}));
          this.set("breezingPlant", _.extend(breezingPlant, {type  : "", quantity : this.get("breezingPlant").quantity}));
        }
        this.checkValidity();
        this.get("eventAggregator").trigger("combinedType:updated");
      },

      setHeatingType            : function(newHeatingType)  {
        if ((newHeatingType==="")||((this.get("combinedPlant").quantity ? this.get("combinedPlant").quantity : 0)+(this.get("heatingPlant").quantity ? this.get("heatingPlant").quantity : 0)+(this.get("breezingPlant").quantity ? this.get("breezingPlant").quantity : 0)<9)) {
          var heatingPlant    = _.extend({},this.get("heatingPlant"));
          if (newHeatingType==="")
            this.set("heatingPlant", _.extend(heatingPlant, {type  : newHeatingType, quantity : 0}));
          else
            this.set("heatingPlant", _.extend(heatingPlant, {type  : newHeatingType, quantity : this.get("heatingPlant").minValue}));
          this.checkValidity();

          this.get("eventAggregator").trigger("heatingType:updated");
          return true;
        }
        else {
          alert($.i18n._("IDS_W1_9101"));
          return false;
        }
      },

      setBreezingType          : function(newBreezingType)  {
        if ((newBreezingType==="")||(this.get("combinedPlant").quantity+this.get("heatingPlant").quantity+this.get("breezingPlant").quantity<9)) {
          var breezingPlant   = _.extend({},this.get("breezingPlant"));
          if (newBreezingType==="")
            this.set("breezingPlant", _.extend(breezingPlant, {type  : newBreezingType, quantity : 0}));
          else
            this.set("breezingPlant", _.extend(breezingPlant, {type  : newBreezingType, quantity : this.get("breezingPlant").minValue}));
          this.checkValidity();

          this.get("eventAggregator").trigger("breezingType:updated");
          return true;
        }
        else {
          alert($.i18n._("IDS_W1_9101"));
          return false;
        }
      },

      fetchTypes                : function()      {
        var that = this;
        BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("207", function(data) {

          //Sorting elements by packageClassId
          that.fetchedTypes = data.packages;

          var currentpackageClassid = "-1";
          for (var i = 0; i<that.fetchedTypes.length; i++)
          {
            if (currentpackageClassid!==that.fetchedTypes[i].packageClassId)
              currentpackageClassid = that.fetchedTypes[i].packageClassId;
            else
            {
              that.fetchedTypes.splice(i,1);
              i--;
            }
          }
          that.set("types", that.fetchedTypes);

          _.each(that.get("types"), function(type) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(type.packageClassId, function(data) {
              data.products         = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              _.extend(type, data.products[0]);
              if ((BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel"))&&(BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel").get("maxZoneNumber")==4))
                that.set("types", _.filter(that.get("types"), function(type) {return type.packageClassId!=="2054";}));

              that.get("eventAggregator").trigger("types:fetched");
            });
          });
        });
      },

      theresOneFancoil          : function()      {
        var theresOneFancoil = false;
        if  (
              (this.get("combinedPlant").type=="2053")||
              (this.get("combinedPlant").type=="2054")||
              (this.get("heatingPlant").type=="2053") ||
              (this.get("heatingPlant").type=="2054") ||
              (this.get("breezingPlant").type=="2053")||
              (this.get("breezingPlant").type=="2054")
            )
          theresOneFancoil = true;
        return theresOneFancoil;
      },

      disablePlantType          : function()      {
        this.trigger("disablePlantTypeSelector");
      },

      enablePlantType    : function()             {
        this.trigger("enablePlantTypeSelector");
      },

      removeClimavenetaProducts   :  function() {
        var combinedPlant = _.extend({}, this.get("combinedPlant"));
        var heatingPlant  = _.extend({}, this.get("heatingPlant"));
        var breezingPlant = _.extend({}, this.get("breezingPlant"));

        if (this.get("combinedPlant").type=="2054") {
          combinedPlant.quantity  = 0;
          combinedPlant.type      = "";
          this.set("combinedPlant", combinedPlant);
        }

        if (this.get("heatingPlant").type=="2054") {
          heatingPlant.quantity  = 0;
          heatingPlant.type      = "";
          this.set("heatingPlant", heatingPlant);
        }

        if (this.get("breezingPlant").type=="2054") {
          breezingPlant.quantity  = 0;
          breezingPlant.type      = "";
          this.set("breezingPlant", breezingPlant);
        }
        this.fetchTypes();
        this.get("eventAggregator").trigger("breezingType:updated"); //Used just to trigger
      }
    })
  });

  // Required, return the module for AMD compliance
  return solenoidValves;

});